@if (isOpen()) {
  <div
    class="flex w-80 flex-col gap-3 rounded-lg border border-gray-400 bg-white p-3 text-black shadow-md">
    <div class="flex items-center gap-5">
      <input
        #searchInput
        [(ngModel)]="searchString"
        class="min-w-0 grow rounded-lg border border-gray-400 p-1"
        placeholder="Suche..." />
      <button class="ml-auto h-5 w-5" (click)="toggle()">
        <span class="material-icons text-gray-600">close</span>
      </button>
    </div>
    <input type="range" min="0.1" max="1" step="0.1" [(ngModel)]="similarityThreshold" />
    @if (foundWordsCount() !== null && foundWordsCount() !== undefined) {
      <span>Gefundene Wörter: {{ foundWordsCount() }}</span>
    } @else {
      <span>Suchbegriff eingeben → Enter drücken</span>
    }
  </div>
}
